import React, { Component } from 'react';
import { Preloader } from '../../../components/common';

class PayoutSetup extends Component {
  constructor(props) {
    super(props);

    this.handleConnect = this.handleConnect.bind(this);
  }

  async getRedirectInfo() {
    return API.makeRequest('post', '/api/payouts/stripe');
  }

  async handleConnect() {

  }

  render() {
    return (
      <>
        <div className="text-center box">
          {
            this.props.url
              ? (
                <>
                  <img src="../../../../static/icon-bank.svg" className="bank-icon" alt="bank-icon" />
                  <h3>Set up an account with Stripe</h3>
                  <p>
                    My Breakup Registry partners with Stripe to transfer donations to your bank
                    account.
                  </p>

                  <a href={this.props.url} className="stripe-connect slate"><span>Connect with</span></a>


                  <p className="text-center notice">
                    You'll be redirected to Stripe to complete the onboarding process.
                  </p>
                </>
              )
              : <Preloader />
          }
        </div>
      </>
    );
  }
}

export default PayoutSetup;
